module.exports = __webpack_public_path__ + "static/media/placeholderImg.d642ee2e.png";